export default __webpack_public_path__ + "473474b35c6b708d9bf45a2227a45bff.svg";